module.exports = __webpack_public_path__ + "static/1-b7e5465e5d0d2c1fffc09ba79a98e0aa.jpg";